"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    data: _propTypes.default.object,
    theme: _propTypes.default.string,
    templateType: _propTypes.default.oneOf(_constant2.ARR_TEMPLATE_TYPE),
    columnSpan: _propTypes.default.oneOf(_constant2.ARR_COLUMN_SPAN),
    cardConfig: _propTypes.default.object,
    cardWidth: _propTypes.default.number,
    gaID: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    templateType: _constant2.TEMPLATE_TYPE.PRODUCT_CARD
  }
};
exports.default = _default;